/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import './EnterprisePage.scss';

export default function EnterprisePage() {
  const { t, i18n } = useTranslation(['enterprise_page', 'community_page', 'notifications']);
  const { industryKey, enterpriseId } = useParams();
  const [enterpriseData, setEnterpriseData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'instant',
    });
  }, []);

  useEffect(() => {
    const header = document.querySelector('.Header.fixed');
    const enterprisePage = document.querySelector('.EnterprisePage');
    const footer = document.querySelector('.Footer');

    if (header && enterprisePage && footer) {
      const minimumRequiredHeight = document.documentElement.clientHeight - (header.offsetHeight + footer.offsetHeight);
      enterprisePage.style.minHeight = `${minimumRequiredHeight}px`;
    }
  }, []);

  useEffect(() => {
    if (industryKey && enterpriseId) {
      setLoading(true);
      fetch(`/enterprises/${i18n.language}.json`)
        .then((response) => response.json())
        .then((data) => {
          if (data[industryKey] && data[industryKey][parseInt(enterpriseId, 10) - 1]) {
            setEnterpriseData(data[industryKey][parseInt(enterpriseId, 10) - 1]);
          }
          setLoading(false);
        });
    }
  }, [industryKey, enterpriseId, i18n.language]);

  const renderWebsiteLinks = (websites) => {
    if (!websites) return null;

    const websiteList = websites.trim().split(/\s+/);

    return (
      <div className="company-info">
        <span className="info-label">
          {t('website')}
        </span>
        <div className="website-links">
          {websiteList.map((website) => (
            <a
              key={`website-${website}`}
              href={website.startsWith('http') ? website : `https://${website}`}
              target="_blank"
              rel="noopener noreferrer"
              className="website-link"
            >
              {website}
            </a>
          ))}
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <section className="EnterprisePage">
        <div className="wrapper">
          <div className="enterprise-page-content">
            <div className="loading">{t('loading')}</div>
          </div>
        </div>
      </section>
    );
  }

  if (!enterpriseData) {
    return (
      <section className="EnterprisePage">
        <div className="wrapper">
          <div className="enterprise-page-content">
            <div className="no-data">
              <p>{t('enterprise_not_found')}</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="EnterprisePage">
      <div className="wrapper">
        <div className="enterprise-page-content">
          <div className="enterprise-page-content-top-row">
            <a
              className="previous-page-link"
              href={`/community/${industryKey}/`}
            >
              {t('previous')}
            </a>
            <h1 className="heading-one">
              {enterpriseData.company_name}
            </h1>
          </div>

          <div className="enterprise-card">

            <div className="enterprise-details">
              <div className="enterprise-logo-container">
                <img
                  src={
                    enterpriseData.logo && enterpriseData.logo.trim() !== ''
                      ? `/enterprises/logos/${enterpriseData.logo}`
                      : '/logo_big.png'
                  }
                  alt={`${enterpriseData.company_name} logo`}
                  className="enterprise-logo"
                />
              </div>
              {enterpriseData.website && renderWebsiteLinks(enterpriseData.website)}

              {enterpriseData.contact_phones && (
                <div className="company-info">
                  <span className="info-label">
                    {t('phone')}
                  </span>
                  <span className="phone-number">{enterpriseData.contact_phones}</span>
                </div>
              )}

              {enterpriseData.postal_address && (
                <div className="company-info">
                  <span className="info-label">
                    {t('postal_address')}
                  </span>
                  <span className="address-text">{enterpriseData.postal_address}</span>
                </div>
              )}

              {enterpriseData.legal_address && (
                <div className="company-info">
                  <span className="info-label">
                    {t('legal_address')}
                  </span>
                  <span className="address-text">{enterpriseData.legal_address}</span>
                </div>
              )}

              {enterpriseData.actual_address && (
                <div className="company-info">
                  <span className="info-label">
                    {t('actual_address')}
                  </span>
                  <span className="address-text">{enterpriseData.actual_address}</span>
                </div>
              )}

              {enterpriseData.email && (
                <div className="company-info">
                  <span className="info-label">
                    {t('email')}
                  </span>
                  <span className="email-text">{enterpriseData.email}</span>
                </div>
              )}

              {enterpriseData.company_profile && (
                <div className="company-info">
                  <span className="info-label">
                    {t('company_profile')}
                  </span>
                  <p className="description-text">{enterpriseData.company_profile}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
